import { FaSpinner, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const SyncProgress = ({ productsStatus, ordersStatus }) => {
  const renderStatus = (status, label) => {
    const { status: state, progress } = status;

    return (
      <div className="mb-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-lg font-medium text-gray-700">{label}</span>
          <span className="text-sm text-gray-500">
            {state === 'completed' ? '100%' : `${progress}%`}
          </span>
        </div>

        {/* Progress Bar */}
        <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
          <div
            className={`h-full transition-all duration-500 ${
              state === 'completed'
                ? 'bg-green-500'
                : state === 'running'
                ? 'bg-blue-500 animate-pulse'
                : state === 'failed'
                ? 'bg-red-500'
                : 'bg-gray-300'
            }`}
            style={{ width: `${state === 'completed' ? 100 : progress}%` }}
          />
        </div>

        {/* Status Icon and Text */}
        <div className="flex items-center mt-2">
          {state === 'idle' && (
            <span className="text-sm text-gray-500">Waiting to start...</span>
          )}
          {state === 'running' && (
            <>
              <FaSpinner className="animate-spin text-blue-500 mr-2" />
              <span className="text-sm text-blue-600">Syncing...</span>
            </>
          )}
          {state === 'completed' && (
            <>
              <FaCheckCircle className="text-green-500 mr-2" />
              <span className="text-sm text-green-600">Completed</span>
            </>
          )}
          {state === 'failed' && (
            <>
              <FaTimesCircle className="text-red-500 mr-2" />
              <span className="text-sm text-red-600">Failed</span>
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="bg-gray-50 rounded-lg p-6">
      <h3 className="text-xl font-semibold text-gray-900 mb-6">Sync Progress</h3>
      {renderStatus(productsStatus, 'Products')}
      {renderStatus(ordersStatus, 'Orders')}
    </div>
  );
};

export default SyncProgress;
